import PropTypes from 'prop-types';
import styled, { css } from 'styled-components/macro';

import React, { useState, useRef, useEffect } from 'react';

import coords from '../app/editor/coords';

const StyledG = styled.g`
  ${(props) =>
    props.hasCursor &&
    css`
      cursor: ${props.isDragging ? 'grabbing' : 'grab'};
    `}
`;

/**
 * Similar to Draggable.jsx but for an SVG canvas
 */
function DraggableSvg(props) {
  const {
    onMouseMove,
    onMouseUp,
    onMouseDown,
    onClick,
    hasCursor,
    children,
    svgRef,
  } = props;

  const [isDragging, setIsDragging] = useState(false);
  const previousCoords = useRef();

  const handleMouseUp = (e) => {
    onMouseUp(e);
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      e.stopPropagation();
      e.preventDefault();

      const svgCoords = coords.getSvgCoords(svgRef.current, e);

      const dx = svgCoords.x - previousCoords.current.x;
      const dy = svgCoords.y - previousCoords.current.y;

      // Callback
      onMouseMove({ dx, dy }, e);

      previousCoords.current = svgCoords;
    }
  };

  useEffect(() => {
    window.addEventListener('mouseup', handleMouseUp);
    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('mousemove', handleMouseMove);
    };
    // eslint-disable-next-line
  }, [isDragging]);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    onMouseDown(e);

    previousCoords.current = coords.getSvgCoords(svgRef.current, e);
  };

  return (
    <StyledG
      isDragging={isDragging}
      hasCursor={hasCursor}
      onMouseDown={handleMouseDown}
      onClick={onClick}
    >
      {children}
    </StyledG>
  );
}

const {
  func,
  shape,
  instanceOf,
  number,
  node,
  arrayOf,
  bool,
  oneOfType,
} = PropTypes;

DraggableSvg.propTypes = {
  onMouseMove: func,
  onMouseDown: func,
  onMouseUp: func,
  onClick: func,
  svgRef: shape({
    current: instanceOf(Element),
  }).isRequired,
  viewport: shape({
    h: number,
    w: number,
  }),
  children: oneOfType([arrayOf(node), node]),
  hasCursor: bool,
};

DraggableSvg.defaultProps = {
  onMouseMove: () => {},
  onClick: () => {},
  onMouseUp: () => {},
  onMouseDown: () => {},
  children: null,
  hasCursor: false,
  viewport: { w: 1920, h: 1080 },
};

export default DraggableSvg;
